import { ListVideos } from "./ListVideos/ListVideos";
import { FilterProvider } from "./context/FilterProvider";
import Filter from "./Filter/Filter";
import SearchBar from "./Filter/SearchBar";

import styled from "styled-components";

function App() {
	const cat = document.getElementById("video-cat")?.textContent;
	return (
		<div className="sos-video-wrapper">
			<FilterProvider cat={cat}>
				<StyledFilterSection className="styled-filters">
					<SearchBar />
					<Filter />
				</StyledFilterSection>
				<ListVideos />
			</FilterProvider>
		</div>
	);
}

export default App;

const StyledFilterSection = styled.section`
	display: flex;
	align-content: center;
	align-items: center;
	justify-content: space-between;

	form {
		width: 100%;
		display: flex;

		input {
			width: 100%;
			margin: 0;
		}
	}

	section {
		width: 20%;
	}
`;
